<template>
  <t-layout>
    <div style="min-height: calc(100vh - 48px)" class="container">
      <div class="content">
        <div class="head">请向商户出示</div>
        <div class="card">
          <img
            src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/coupon/95coupon/tag-icon.png"
            class="tag"
          />
          <img
            src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/coupon/95coupon/sunrise-logo.png"
            class="logo"
          />
          <div class="label">日上会员卡</div>
          <div class="title">日上免税行（上海）9.5折优惠</div>
          <div class="qrcode">
            <img class="code-img" :src="qrcodeImage" />
            <img
              class="center-logo"
              src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/coupon/95coupon/center-logo.png"
            />
          </div>
          <div class="tips">门店付款时出示此二维码即可享受优惠</div>

          <div class="shop">
            <div class="name">使用门店</div>
            <div class="list">
              <div class="item">上海浦东国际机场T1/T2/S1/S2(出、入境 日上免税店)</div>
              <div class="item">上海虹桥机场T1(出、入境 日上免税店)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </t-layout>
</template>

<script>
const channelMap = {
  wanzhuan001: {
    title: '购乐帮x日上95折',
    type: 1
  },
  wanzhuan002: {
    title: '畅游日本x日上95折',
    type: 2
  },
  wanzhuan003: {
    title: '飞常准x日上95折',
    type: 2
  },
  wanzhuan004: {
    title: '嬉游x日上95折',
    type: 2
  },
  wanzhuan005: {
    title: '渠道5',
    type: 3
  }
}
export default {
  name: 'couponsCardView',
  components: {},
  data() {
    return {
      countdown: 60,
      qrcodeImage: '',
      channel: 'wanzhuan001',
      current: channelMap['wanzhuan001'],
      title: ''
    }
  },
  created() {
    this.$store.commit('setTitle', '日上会员')

    const options = this.$route.query
    if (options.channel) {
      this.channel = options.channel
      this.current = channelMap[options.channel] || null
    }
    if (options.title) {
      this.title = decodeURIComponent(options.title)
    }
  },

  activated() {
    this.initPage()
  },

  deactivated() {
    this.tt && clearInterval(this.tt)
  },

  destoryed() {
    this.tt && clearInterval(this.tt)
  },

  methods: {
    initPage() {
      this.getQrcodeImage()
    },

    getQrcodeImage(cb = null) {
      let baseURL = process.env.VUE_APP_API_URL
      this.startCountdown(60)
      const url = `${baseURL}/api/v1/shop/qrcode?channel=${this.channel}&v=${new Date().getTime()}`
      console.log('url', url)
      this.qrcodeImage = url
      cb && cb()
    },

    startCountdown(seconds) {
      this.tt && clearInterval(this.tt)
      this.countdown = seconds
      this.tt = setInterval(() => {
        // console.log('seconds', seconds)
        seconds--
        if (seconds >= 0) {
          this.countdown = seconds
        } else {
          this.getQrcodeImage()
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background-position: 0 0;
  background-size: 100% 100%;
  background-image: linear-gradient(315deg, #fed383 4.46%, #f7e6bb 98.71%);
  background-repeat: no-repeat;
}

.content {
  color: #000;
  padding: 30rpx;

  > .head {
    text-align: center;
    line-height: 42rpx;
    font-size: 30rpx;
    margin-bottom: 28rpx;
  }

  .card {
    width: 100%;
    border-radius: 30rpx;
    background: #fff;
    padding: 20rpx 20rpx 40rpx;

    .tag {
      width: 118rpx;
      height: 53rpx;
      display: block;
      margin: 10rpx 0 0 10rpx;
    }

    .logo {
      width: 218rpx;
      height: 36rpx;
      display: block;
      margin: 32rpx auto 36rpx;
    }

    .label {
      text-align: center;
      font-size: 26rpx;
      color: #666666;
      line-height: 36rpx;
      margin-bottom: 20rpx;
    }

    .title {
      width: 400rpx;
      height: 46rpx;
      border-radius: 24rpx;
      background: #f9dfa5;
      margin: 0 auto 26rpx;
      color: #000;
      text-align: center;
      font-size: 26rpx;
      line-height: 46rpx;
    }

    .qrcode {
      margin: 0 auto 40rpx;
      width: 400rpx;
      height: 400rpx;
      position: relative;

      .code-img {
        display: block;
        width: 100%;
        height: 100%;
        border: 1rpx solid rgba(145, 190, 197, 0.2);
      }

      .center-logo {
        display: block;
        width: 100rpx;
        height: 100rpx;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    .tips {
      font-size: 24rpx;
      color: #666666;
      line-height: 34rpx;
      margin-bottom: 68rpx;
      text-align: center;
    }

    .shop {
      width: 650rpx;
      height: 198rpx;
      border-radius: 30rpx;
      background: #f5f5f5;
      padding: 26rpx 30rpx 36rpx;

      .name {
        font-size: 28rpx;
        line-height: 40rpx;
        color: #000;
        margin-bottom: 12rpx;
      }

      .list {
        .item {
          font-size: 24rpx;
          color: #666666;
          line-height: 34rpx;
          margin-bottom: 18rpx;
        }
      }
    }
  }
}
</style>
